// Small DOM helpers, ported from source lines 3049-3089.
export const $ = <T extends Element = HTMLElement>(sel: string, root?: ParentNode): T | null => (root ?? document).querySelector<T>(sel);
export const $$ = <T extends Element = HTMLElement>(sel: string, root?: ParentNode): T[] => Array.from((root ?? document).querySelectorAll<T>(sel));

export function escapeHtml(s: unknown): string {
  if (s === null || s === undefined) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString("fr-FR");
}

export function fmtDateOnly(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString("fr-FR");
}

export function calcAge(dob: string | null | undefined): string {
  if (!dob) return "—";
  const birth = new Date(dob);
  if (Number.isNaN(birth.getTime())) return "—";
  const diffMs = Date.now() - birth.getTime();
  const years = diffMs / (1000 * 60 * 60 * 24 * 365.25);
  return `${years.toFixed(1)} ans`;
}

export function openModal(title: string, bodyHtml: string, footerHtml = "", large = false): void {
  $("#modalTitle")!.textContent = title;
  $("#modalBody")!.innerHTML = bodyHtml;
  $("#modalFooter")!.innerHTML = footerHtml;
  const container = $("#modalContainer")!;
  container.classList.toggle("modal-large", large);
  $("#modalOverlay")!.classList.add("active");
}

export function closeModal(): void {
  $("#modalOverlay")!.classList.remove("active");
}

// Replaces window.alert() everywhere in the app - a non-blocking toast
// stacked top-center, color-coded per type ("type: message" format), above
// the modal overlay so validation errors raised from within an open modal
// still surface (see styles.css's "TOAST NOTIFICATIONS" section).
export type NotifyType = "error" | "warning" | "success";

const NOTIFY_LABELS: Record<NotifyType, string> = {
  error: "Erreur",
  warning: "Attention",
  success: "Succès",
};

const NOTIFY_DURATION_MS = 6000;

function getToastContainer(): HTMLElement {
  let container = document.getElementById("toastContainer");
  if (!container) {
    container = document.createElement("div");
    container.id = "toastContainer";
    container.className = "toast-container";
    document.body.appendChild(container);
  }
  return container;
}

export function notify(type: NotifyType, message: string): void {
  const container = getToastContainer();
  const toast = document.createElement("div");
  toast.className = `toast toast-${type}`;
  const messageHtml = escapeHtml(message).replace(/\n/g, "<br>");
  toast.innerHTML = `<span class="toast-msg"><strong>${escapeHtml(NOTIFY_LABELS[type])} :</strong> ${messageHtml}</span><button class="toast-close" aria-label="Fermer">×</button>`;
  container.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add("toast-in"));

  const dismiss = (): void => {
    toast.classList.remove("toast-in");
    toast.classList.add("toast-out");
    toast.addEventListener("transitionend", () => toast.remove(), { once: true });
  };
  toast.querySelector(".toast-close")!.addEventListener("click", dismiss);
  setTimeout(dismiss, NOTIFY_DURATION_MS);
}

export function showError(el: Element | null, message: string): void {
  if (!el) return;
  el.textContent = message;
  el.classList.remove("hidden");
}

export function hideError(el: Element | null): void {
  if (!el) return;
  el.classList.add("hidden");
}
